import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/components/application/ApplicationPage.tsx");
